import { render, staticRenderFns } from "./PaymentDetailsModel.vue?vue&type=template&id=85434fc0&scoped=true"
import script from "./PaymentDetailsModel.vue?vue&type=script&lang=js"
export * from "./PaymentDetailsModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85434fc0",
  null
  
)

export default component.exports